import React, { useState, Fragment, useEffect } from "react";
import moment from "moment";
import ButtonSwitcher from "../../../components/ButtonSwitcher";

import EventInfo from "./EventInfo";
import EventMedia from "./EventMedia";
import ContentTags from "./ContentTags";

import "./AddEvent.css";

const tabs = ["Event info", "Event media", "Content tags"];
const initEvent = {
  title: "",
  // postcode: "",
  // building: "",
  description: "",
  address: { formatted_address: "", building: "", postcode: "" },
  token: 0,
  price: null,
  day: 0,
  type: "physical",
  redemptionType: "rsvp",
  isrecurring: true,
  selectedDate: null,
  start_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  end_time: { hh: "00", mm: "00", of: "am", utc: 0 },
  purchaseType: "quickbuy",
  mediaUrl: "",
  contentType: "",
  article: {},
};

const AddEvent = ({
  createEvent,
  articles,
  hotTopicTags,
  products,
  hex,
  white,
}) => {
  const [tab, setTab] = useState(tabs[0]);
  const [event, setEvent] = useState(initEvent);

  const handleChangeTab = (tab) => {
    setTab(tab);
  };

  const handleClickCreate = () => {
    const {
      title,
      token,
      postcode,
      address,
      isrecurring,
      day,
      selectedDay,
      start_time,
      end_time,
      type,
      date,
      building,
      description,
      selectedDate,
      contentType,
      mediaUrl,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    } = event;
    let time = null;
    let payload = {
      title,
      type: type,
      address,
      start_time,
      end_time,
      isrecurring,
      description,
      selectedDate,
      token: Number(token),
      media_type: contentType.value || "",
      media_url: mediaUrl,
      purchaseType,
      redemptionType,
      price,
      article: article ? article : null,
      hotTopicTag: hotTopicTag ? hotTopicTag : null,
      productTag: productTag ? productTag : null,
    };

    if (!isrecurring) {
      const { hh, mm, of, utc } = start_time;
      let hours = Number(hh);
      let minutes = Number(mm);
      if (of === "pm" && hours < 12) hours = hours + 12;
      if (of === "am" && hours === 12) hours = hours - 12;
      let m = moment();
      m.utcOffset(utc);
      const new_date = new Date(
        `${date}T${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:00`
      );
      const newDate = moment(new_date);
      m.set(newDate.toObject());
      time = m.valueOf(); //m.toDate();
      payload.time = time;
      payload.date = date;
      // console.log("time", moment(time).toDate());
      // console.log("date", date);
    } else {
      payload.day = day;
    }
    createEvent(payload);
  };

  const onChangeEventInfo = (eventInfo) => {
    setEvent({ ...event, ...eventInfo });
  };

  const onChangeMedia = (media) => {
    setEvent({ ...event, ...media });
  };

  const onChangeTags = (tags) => {
    setEvent({ ...event, ...tags });
  };

  const checkValidation = () => {
    const {
      title,
      token,
      address,
      date,
      isrecurring,
      building,
      description,
      selectedDate,
      type,
    } = event;

    const date_validation = isrecurring ? true : date;
    const title_validation = title ? true : false;
    const address_validation =
      type === "physical" ? (address ? true : false) : true;
    const token_validation = token ? true : false;
    const building_validation =
      type === "physical" ? (address.building ? true : false) : true;
    const description_validation = description ? true : false;
    const validation =
      title_validation &&
      address_validation &&
      token_validation &&
      building_validation &&
      description_validation &&
      (date_validation || selectedDate);
    return validation;
  };

  return (
    <div
      className="modal fade add-event-dialog"
      id="add_event_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-event-content">
          <div className="modal-header">
            <h5 className="modal-title">Add an event</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 add-event-dialog-body">
            <div className="swtich-bar-container">
              <ButtonSwitcher
                buttonsGroup={tabs}
                currentTab={tab}
                onSwitch={handleChangeTab}
                hex={hex}
                white={white}
              />
            </div>
            <EventInfo
              onChangeEventInfo={onChangeEventInfo}
              isVisible={tab === "Event info" ? true : false}
            />
            <EventMedia
              onChangeMedia={onChangeMedia}
              isVisible={tab === "Event media" ? true : false}
            />
            <ContentTags
              onChangeTags={onChangeTags}
              articles={articles}
              hotTopicTags={hotTopicTags}
              products={products}
              isVisible={tab === "Content tags" ? true : false}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Event info" && (
                <button
                  type="button"
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": "black",
                    "--hover-color": "white",
                    backgroundColor: hex || "white",
                    color: white ? "white" : "black",
                  }}
                  onClick={() => setTab("Event media")}
                >
                  Next
                </button>
              )}
              {tab === "Event media" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Event info")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-hex btn-white"
                    style={{
                      "--hover-text-color": "black",
                      "--hover-color": "white",
                      backgroundColor: hex || "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Content tags")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Content tags" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Event media")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    disabled={!checkValidation()}
                    onClick={handleClickCreate}
                  >
                    Create
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;



// WEBPACK FOOTER //
// ./src/screens/Event/components/AddEvent.js